document.addEventListener('DOMContentLoaded', () => {
    const copyButtons = document.querySelectorAll('.code-copy__button');

    if (!copyButtons.length) {
        return;
    }

    copyButtons.forEach((button) => {
        const copyTextElement = button.querySelector('.copy-text');
        const defaultLabel = copyTextElement?.innerHTML || 'Copy Link';
        const urlToCopy = button.dataset.copy;

        if (!urlToCopy || !copyTextElement) {
            return;
        }

        button.addEventListener('click', () => {
            if (!navigator.clipboard) {
                return;
            }

            navigator.clipboard.writeText(urlToCopy).then(() => {
                copyTextElement.innerHTML = 'Copied';
                setTimeout(() => {
                    copyTextElement.innerHTML = defaultLabel;
                }, 1000);
            });
        });
    });
});

